import { ServiceComplaintTypeDetailDialogStore } from './service-complaint-type-detail-dialog.store';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import {
    fb,
    routeParams,
} from '../../../../../modules/shared/shared.global-service';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { NumberInputComponent } from '../../../../kit/input/text-input/number-input.component';
import {
    ServiceComplaintTypeCreateInput,
} from '@libs/types/src/services/input-type/services/settings/service-complaint-type.create-input';
import {
    ServiceComplaintTypeUpdateInput,
} from '@libs/types/src/services/input-type/services/settings/service-complaint-type.update-input';
import { Validators } from '@angular/forms';
import { CheckInputComponent } from '../../../../kit/input/check-input/check-input.component';

@Component({
    selector: 'app-service-complaint-type-detail-dialog',
    templateUrl: './service-complaint-type-detail-dialog.component.html',
    styleUrl: './service-complaint-type-detail-dialog.component.scss',
    standalone: true,
    providers: [ServiceComplaintTypeDetailDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextInputComponent,
        NumberInputComponent,
        CheckInputComponent,
    ],
})
export class ServiceComplaintTypeDetailDialogComponent extends BaseDialogComponent {
    public readonly store = inject(ServiceComplaintTypeDetailDialogStore);

    protected form = fb.group({
        name: fb.control<string | null>(null, Validators.required),
        active: fb.control<boolean>(true),
        daysToProcess: fb.control<number | null>(null, Validators.required),
    });

    protected prefix = 'service.complaintType.';

    private complaintTypeId = 0;

    constructor() {
        super();
        const data = this.dialogConfig.data;
        if (data?.complaintType) {
            const complaintType = data.complaintType;
            this.complaintTypeId = complaintType?.id;
            this.form.patchValue(complaintType);
        }
    }

    public override async save(_event: Event): Promise<void> {
        if (isInvalid(this.form)) return;

        const base = { ...this.form.value } as any;

        let resOk = false;
        if (this.complaintTypeId) {
            const data = base as ServiceComplaintTypeUpdateInput;
            data.id = this.complaintTypeId;
            const res = await this.store.api.updateComplaintType(data);
            if (res?.ok) {
                resOk = true;
                contentGlobalSuccess.next('common.updated');
            }
        } else {
            const data = base as ServiceComplaintTypeCreateInput;
            data.serviceId = Number(routeParams.serviceId());
            const res = await this.store.api.createComplaintType(data);
            if (res?.ok) {
                resOk = true;
                contentGlobalSuccess.next('common.created');
            }
        }
        if (!resOk) return;
        this.dialogRef.close(true);
    }
}


